import styled from '@emotion/styled'
import { Button } from '@mui/material'
import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { scale } from '../../../utils/scale'
import { ColumnFlex, VisuallyHidden } from '../../Layout/Layout'
import { Text } from '../../Typography/Typography'

const Heading = styled(Text)`
  margin-top: ${scale(2)};
  margin-bottom: 8px;
  padding: 0 64px;
  text-align: center;
`

const Suggestion = styled(Text)`
  padding: 0 16px 16px;
  text-align: center;
`

type Props = {
  onClick: () => void
}

const NoResults: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()

  const [searchError, setSearchError] = useState<string>('')

  useEffect(() => {
    setTimeout(() => {
      setSearchError(t('component.search.noResults'))
    }, 100)
  })

  return (
    <ColumnFlex>
      <VisuallyHidden>
        <div role="alert">{searchError.length > 0 && <p>{searchError}</p>}</div>
      </VisuallyHidden>
      <Heading as="h2" $size={400} $weight="Medium" $height="Medium">
        {t('component.search.noResults')}
      </Heading>
      <Suggestion $font-size={300}>{t('component.search.checkSpelling')}</Suggestion>
      <Button onClick={onClick} variant="text" size="medium" color="primary">
        {t('component.search.allItems')}
      </Button>
    </ColumnFlex>
  )
}

export default NoResults
